import React from 'react';
import './LegalPage.css';

function TermsOfService() {
  return (
    <div className="legal-page-container">
      <div className="legal-page-card">
        <div className="logo-container">
          <img src="/acta-logo.jpg" alt="Acta Extension" className="acta-logo" />
        </div>
        <h1>Acta Extension 利用規約</h1>

        <div className="legal-content">
          <h2>第1条（目的）</h2>
          <p>1. 本利用規約（以下「本規約」といいます。）は、ナウビレッジ株式会社（以下「当社」といいます。）が提供するHubSpotおよびSlack連携クラウド型ソフトウェアサービス『Acta Extension』（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスの名称又は内容が変更された場合は、当該変更後のサービスを含むものとします。ユーザー（第2条に定義）は、本規約に同意のうえ本サービスを利用するものとします。</p>
          <p>2. 本規約は、本サービスの提供条件および当社とユーザーの権利義務関係を定めるものです。ユーザーは本規約に従って本サービスを利用します。</p>
          <p>3. ユーザーが当社所定のオンライン申込手続を完了した時点で、当社とユーザーの間に、本規約に基づく本サービスの利用に関する契約関係が成立します。</p>
          <p>4. 本サービスの内容は、本規約その他当社がユーザーに対して通知又は公表する仕様書、ヘルプページ、料金ページその他の書面に定めるものとします。</p>
          <p>5. 本サービスは HubSpot, Inc. および Slack Technologies, LLC の製品と連携して動作しますが、両社とは独立して提供されるものであり、いずれによる保証又はサポートの対象ではありません。</p>
          <p>6. 当社が本サービスに関して別途定めるガイドライン、マニュアル、個別規定その他の細則等がある場合、当該細則等は本規約の一部を構成するものとし、本規約とこれら細則等の内容が矛盾する場合には、当該細則等の定めが優先して適用されるものとします。</p>

          <h2>第2条（定義）</h2>
          <p>本規約において使用する以下の用語は、以下の各号に定める意味を有します。</p>
          <p>1. 「本契約」：本規約を契約条件とする、本サービスの利用に関する契約をいいます。</p>
          <p>2. 「ユーザー」：本規約に同意し、事業として本サービスを利用する法人又は個人事業主その他の事業者をいいます。</p>
          <p>3. 「アカウント情報」：ユーザーが本サービスの利用にあたり登録するID、パスワードその他の認証に関する情報をいいます。</p>
          <p>4. 「HubSpotデータ」：ユーザーのHubSpotアカウントに保存されているすべてのデータをいいます。</p>
          <p>5. 「Slackデータ」：ユーザーのSlackワークスペース内のメッセージ、チャンネル情報、ユーザー情報その他のデータをいいます。</p>
          <p>6. 「ユーザーデータ」：本サービスの利用を通じて作成、保存又は処理されるすべてのデータをいいます。</p>
          <p>7. 「利用ユーザー」：ユーザーが本サービス上に登録した、本サービスを実際に利用する者（役員、従業員その他これに準ずる者）をいいます。</p>
          <p>8. 「Hub ID（ポータルID）」：HubSpotにおいて付与される識別子をいい、本サービスにおける契約の成立、契約管理、課金およびFreeプランの利用可否判定の単位となるものをいいます。</p>

          <h2>第3条（利用の前提条件）</h2>
          <p>1. ユーザーは有効な HubSpot アカウントおよび Slack アカウントを保有している必要があります。</p>
          <p>2. ユーザーは、HubSpotおよびSlackの利用規約・API利用規約を遵守するものとします。</p>
          <p>3. 本サービスは、HubSpot管理者によるインストール後、利用ユーザーごとにSlack認証が必要です。</p>

          <h2>第4条（ユーザー登録）</h2>
          <p>1. 本サービスの利用を希望する者は、本規約の内容に同意の上、当社が定める手続によりユーザー登録を行うものとし、登録に際しては自らに関する正確かつ最新の情報を提供するものとします。登録にあたっては、本規約への同意を確認するものとします。</p>
          <p>2. ユーザーは、前項に基づき登録した情報に変更が発生した場合、直ちに、登録情報の変更手続を行う義務を負います。</p>
          <p>3. 当社は、本サービスの登録希望者が以下の各号のいずれかに該当すると判断した場合、当社の裁量により、ユーザー登録を拒否する場合があります。この場合、当社は、当該登録希望者に対して、登録拒否の理由を説明する義務を負いません。</p>
          <ol>
            <li>ユーザーが既に登録済みである場合</li>
            <li>第三者に本サービスを利用させることを目的として登録しようとする場合</li>
            <li>過去に本規約に違反したことがある場合</li>
            <li>登録のために提供された情報に不正確又は虚偽と疑われる情報が含まれている場合</li>
            <li>第23条の保証に違反する事実が認められる場合</li>
            <li>有効なHubSpotアカウントを保有していない場合</li>
            <li>その他当社がユーザーによる本サービスの利用が不適切であると判断する場合</li>
          </ol>
          <p>4. ユーザーは、本サービス上のアカウントを第三者に対して利用、貸与、譲渡、売買又は質入等をすることはできません。</p>

          <h2>第5条（本契約の契約期間）</h2>
          <p>1. 本サービスには、無料プラン（Free）および有料プラン（Standard）があります。</p>
          <p>2. 本契約の有効期間は、ユーザーが当社所定の方法によりStandardプランへアップグレードした日（以下「契約開始日」といいます。）から1か月間とします。</p>
          <p>3. Freeプランは、同一のHub ID（ポータルID）につき1回に限り、初回申込み日から14日間、本サービスを無償で利用できるものとします。Freeプランの利用期間中は、当該期間に係る利用料金の支払義務は発生しません。</p>
          <p>4. 本項の規定は、Standardプランに基づく本契約にのみ適用されるものとします。契約期間満了日の前日までに、ユーザー又は当社から当社所定の方法による解約の意思表示がない限り、本契約は同一条件にて1か月間自動更新されるものとし、以後も同様とします。解約を希望するユーザーは、契約期間満了日の前日までに当社所定の方法により解約の意思表示を行うものとします。</p>
          <p>5. Freeプランの利用期間が終了した場合、当該利用期間の満了をもって本サービスの機能は利用できなくなります。ただし、ユーザーは管理画面（ダッシュボード）を閲覧し、当社所定の方法によりStandardプランへアップグレードすることができます。なお、Freeプランの期間満了により自動的にStandardプラン（有料）へ移行されることはありません。</p>
          <p>6. Freeプランにおいて利用可能な機能の範囲（利用ユーザー数、連携チャンネル数、メッセージ送信数その他の利用上の制限を含みます。）は、当社が別途料金ページその他の書面において定めるものとします。当社は、Freeプランにおける機能の範囲を、ユーザーへの事前の通知により変更することができるものとします。</p>
          <p>7. Freeプランの利用期間中であっても、本規約のうち、利用料金および決済に関する条項を除き、本サービスの利用に関するその他の条項はすべて適用されるものとします。</p>

          <h2>第6条（利用料金および決済方法）</h2>
          <p>1. 本サービスの利用料金は、前条に定めるFreeプランまたはStandardプランのいずれかに基づき決定されます。</p>
          <p>2. 本サービスにおける契約の成立、利用料金の課金およびプランの適用は、Hub ID（ポータルID）単位で管理されます。</p>
          <p>3. Standardプランの利用料金は、利用ユーザー1名につき、月額500円（税別）とします。</p>
          <p>4. Standardプランの利用料金は、ユーザーが管理画面上でStandardプランへアップグレードした日をもって、当社指定の決済手段（Stripe）により課金されます。</p>
          <p>5. ユーザーが契約期間中に利用ユーザーを追加した場合、当該追加は即時に有効となり、追加された利用ユーザーに係る利用料金は、追加日から当該請求期間の末日までの期間について、当社又はStripeの定める方法により日割計算のうえ課金されます。</p>
          <p>6. ユーザーが利用ユーザーを削除した場合、当該削除は次回の請求期間から適用されるものとし、当該請求期間における利用料金の減額又は返金は行われません。</p>
          <p>7. 支払済みの利用料金は、理由の如何を問わず返金されません。</p>

          <h2>第7条（サービスレベル）</h2>
          <p>1. 当社は、本サービスの月間稼働率99.5%を目標として運用しますが、これを保証するものではありません。</p>
          <p>2. 計画的なメンテナンスは、原則として日本時間の深夜帯（午前1時から午前5時）に実施し、7日前までに、当社ウェブサイトへの掲載又は電子メールその他当社所定の方法によりユーザーに通知します。</p>
          <p>3. HubSpot・Slack・Stripeその他の外部サービスのメンテナンス、仕様変更、障害等により本サービスが利用できない場合、当社は責任を負いません。</p>

          <h2>第8条（ユーザー情報、アカウント及び通信機器等に関する管理）</h2>
          <p>1. ユーザーは、本サービスの提供を受けるために必要な機器、通信手段等の環境を全て自らの費用と責任で備えます。また、本サービスの利用にあたり必要となる通信費用は、全てユーザーの負担とします。</p>
          <p>2. ユーザーは、ユーザー情報及び通信機器の管理責任を負います。ユーザー情報及び通信機器の管理不十分、使用上の過誤、第三者の使用等、並びにユーザーが本サービスに関して登録した決済手段、金融機関の情報その他の当社に提供した情報（以下「提供情報」といいます。）の過誤、第三者の利用等による損害の責任はユーザーが負い、当社は当社に故意又は重過失のない限り一切の責任を負いません。</p>
          <p>3. ユーザーは、ユーザー情報、提供情報又は通信機器を第三者に使用されるおそれのある場合は、直ちに当社にその旨を連絡するとともに、当社の指示があるときはこれに従います。</p>
          <p>4. ユーザーは、自己の責任において、本サービスのアカウント、ID及びパスワードを適切に管理・保管し、第三者に利用させ、又は貸与、譲渡、売買若しくは担保提供してはなりません。</p>
          <p>5. 当社は、ログイン時に使用されたID及びパスワードが登録されたものと一致することを所定の方法により確認した場合、当該ログインについてユーザー本人による利用とみなし、これにより生じた結果について当社は責任を負わないものとします。</p>

          <h2>第9条（HubSpotおよびSlackとの連携）</h2>
          <p>1. 本サービスを利用するためには、ユーザーが管理するHubSpotアカウントおよびSlackワークスペースと本サービスを連携させる必要があります。ユーザーは、本サービスの申込みおよび利用にあたり、本サービスが当該HubSpotアカウントおよびSlackワークスペースに対して、連携に必要な範囲でAPIを通じてアクセスし、データを取得、保存、表示その他の処理を行うことを承認し、これに必要な権限を付与するものとします。</p>
          <p>2. 本サービスは、ユーザーのSlackワークスペース内において、当社が提供するBOT（アプリケーション）として動作します。ユーザーは、本サービスを利用するために、当該Slackワークスペースに当該BOTをインストールし、その動作に必要な権限を付与するものとします。</p>
          <p>3. 本サービスをSlackの非公開チャンネルにおいて利用する場合、ユーザーは、自らの責任において、当該BOTを当該非公開チャンネルに招待するものとします。当該BOTが非公開チャンネルに招待されていないことに起因して本サービスの全部又は一部が利用できない場合であっても、当社は一切の責任を負いません。</p>
          <p>4. ユーザーが本条に定める権限付与を行わない場合、又は当該権限を途中で取り消した場合には、本サービスの全部又は一部が利用できなくなることがあります。この場合にユーザーに生じた損害について、当社は一切の責任を負いません。</p>
          <p>5. HubSpot又はSlackの仕様変更、API利用条件の変更、機能制限、サービス停止その他当社の責に帰さない事由により、本サービスの全部又は一部が利用できなくなった場合であっても、当社は一切の責任を負いません。</p>

          <h2>第10条（ユーザーデータの取扱い）</h2>
          <p>1. ユーザーデータの所有権は、ユーザーに帰属します。</p>
          <p>2. 当社は、本サービスの提供に必要な範囲でのみユーザーデータにアクセスし、処理を行います。</p>
          <p>3. 本契約終了後、当社は30日以内にユーザーデータを削除します。ただし、法令により保存が義務付けられている場合はこの限りではありません。</p>
          <p>4. 当社は、本サービスの提供に必要な範囲で、HubSpotが提供するユーザーID、ポータルID、レコードID、ユーザーのメールアドレスその他当社が別途定める情報（以下総称して「コンテキスト情報等」といいます。）及び本サービスの利用状況に関するログ情報を取得し、認証・アクセス制御、利用状況の記録、利用ユーザー数の管理（課金計算を含む）、サポート対応、本サービスの品質改善及び不正利用の防止の目的で利用します。また、当社は、ユーザーデータ及び利用状況に関する情報を、個人を識別できない形式に加工したうえで、統計情報として当社サービスの改善、新サービスの企画・開発その他マーケティングの目的で利用することができるものとします。</p>

          <h2>第11条（知的財産権）</h2>
          <p>1. 本サービスにおいて提供される全ての情報及びコンテンツ（以下総称して「当社コンテンツ」といいます。）に関する著作権、特許権、実用新案権、商標権、意匠権その他一切の知的財産権及びこれらの権利の登録を受ける権利（以下総称して「知的財産権」といいます。）は、当社又は当社がライセンスを受けているライセンサーに帰属し、ユーザーには帰属しません。本規約に基づく本サービスの利用の許諾は、本サービスの利用を超えた当社コンテンツに関する知的財産権の利用を許諾するものではなく、ユーザーは、当社コンテンツについて、複製、配布、転載、転送、公衆送信、改変、翻案その他の二次利用等を行ってはなりません。</p>
          <p>2. ユーザーが本条の規定に違反して問題が発生した場合、ユーザーは、自己の費用と責任において当該問題を解決するとともに、当社に何らの不利益、負担又は損害を与えないよう適切な措置を講じなければなりません。</p>

          <h2>第12条（導入事例等の公開）</h2>
          <p>当社がマーケティング等の目的で、ユーザーが本サービスの利用者である旨若しくはその利用状況等を当社ウェブサイト、営業資料等に記載する場合には、事前にユーザーへ連絡し、その使用又は記載について確認を行うものとします。ユーザーは、当該使用または記載の差し止め若しくは修正を求めることができます。</p>

          <h2>第13条（禁止事項）</h2>
          <p>1. 当社は、ユーザーによる本サービスの利用に際して、以下の各号に定める行為を禁止します。</p>
          <ol>
            <li>本規約に違反する行為</li>
            <li>当社、当社がライセンスを受けているライセンサーその他第三者の知的財産権、肖像権等の財産的又は人格的な権利を侵害する行為又はこれらを侵害するおそれのある行為</li>
            <li>当社又は第三者に不利益若しくは損害を与える行為又はそのおそれのある行為</li>
            <li>不当に他人の名誉や権利、信用を傷つける行為又はそのおそれのある行為</li>
            <li>法令又は条例等に違反する行為</li>
            <li>公序良俗に反する行為若しくはそのおそれのある行為又は公序良俗に反するおそれのある情報を他のユーザー又は第三者に提供する行為</li>
            <li>犯罪行為、犯罪行為に結びつく行為若しくはこれを助長する行為又はそのおそれのある行為</li>
            <li>事実に反する情報又は事実に反するおそれのある情報を提供する行為</li>
            <li>当社のシステムへの不正アクセス、それに伴うプログラムコードの改ざん、位置情報の改ざん、虚偽の情報を入力する行為、通信機器の仕様その他アプリケーションを利用してのチート行為、コンピューターウィルスの頒布その他本サービスの正常な運営を妨げる行為又はそのおそれのある行為</li>
            <li>当社が提供する本サービスの機能の範囲を超えて、本サービスへの不正アクセス、スクレイピング、過負荷をかけることを目的としたマクロその他操作を自動化する機能やツール等を使用する行為</li>
            <li>当社が提供するソフトウェアその他のシステムに対する逆コンパイル、逆アセンブル、リバースエンジニアリングその他の解析行為</li>
            <li>本サービスの信用を損なう行為又はそのおそれのある行為</li>
            <li>他のユーザーのアカウントの使用その他の方法により、第三者になりすまして本サービスを利用する行為</li>
            <li>詐欺、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく又は結びつくおそれのある行為</li>
            <li>犯罪収益に関する行為、テロ資金供与に関する行為又はその疑いがある行為</li>
            <li>HubSpot又はSlackの利用規約若しくはAPI利用規約に違反する行為</li>
            <li>API制限を意図的に超過させる行為</li>
            <li>その他当社が不適当と判断する行為</li>
          </ol>

          <h2>第14条（ユーザーコンテンツの責任）</h2>
          <p>1. ユーザーは、本サービスを通じて送信、投稿、保存又は表示されるメッセージ、ファイルその他一切の情報（以下「ユーザーコンテンツ」といいます。）について、その内容に関し一切の責任を負うものとします。</p>
          <p>2. ユーザーは、ユーザーコンテンツが第三者の権利（著作権、商標権、プライバシー権、営業秘密その他一切の権利を含みます。）を侵害しないよう適切な注意を払うものとします。</p>
          <p>3. 当社は、ユーザーコンテンツの内容を監視、確認又は管理する義務を負わず、その適法性、正確性、有用性等について一切保証しません。</p>

          <h2>第15条（解除）</h2>
          <p>1. 当社は、ユーザーが以下の各号のいずれかに該当した場合、何らの通知等を要することなく、本サービスの全部若しくは一部の利用を停止させ、又は本契約を解除し、本サービスを退会させることができます。この場合、当社は、ユーザーに対して、当該措置を講じた理由を説明する義務を負いません。</p>
          <ol>
            <li>本規約のいずれかの条項に違反した場合</li>
            <li>本規約に基づく債務が履行されない場合</li>
            <li>第4条第3項各号のいずれかに該当する場合</li>
            <li>登録情報に虚偽の情報が含まれている場合</li>
            <li>過去に当社から退会処分を受けていた場合</li>
            <li>支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申し立てがあった場合</li>
            <li>解散又は営業停止した場合</li>
            <li>ユーザーが個人事業主である場合において、その相続人等からユーザーが死亡した旨の連絡があった場合又は当社がユーザーの死亡の事実を確認できた場合</li>
            <li>未成年が法定代理人の同意なく、本サービスを利用した場合</li>
            <li>成年被後見人、被保佐人又は被補助人が、成年後見人、保佐人又は補助人等の同意なく、本サービスを利用した場合</li>
            <li>当社からの要請に対し誠実に対応しない場合</li>
            <li>HubSpotアカウント又はSlackアカウントが無効となった場合</li>
            <li>その他当社が不適当と判断した場合</li>
          </ol>
          <p>2. ユーザーが契約プランの変更等の本契約の内容の変更又は退会を希望する場合、当社が定める手続により、本契約の内容を変更、又は本契約を解除し、本サービスを退会することができます。ただし、利用料金の返金については第6条第7項に定めるとおりとします。</p>
          <p>3. 第1項及び第2項により本サービスを退会したユーザーは、退会時に期限の利益を喪失し、直ちに、当社に対し負担する全ての債務を履行します。また、再度本サービスの登録を行った際に、退会前の情報が引き継がれないことがあることをあらかじめ了承するものとします。</p>

          <h2>第16条（非保証・免責）</h2>
          <p>1. 当社は、本サービスの完全性、正確性、有用性及び有効性等について、保証をしません。また、当社は、本サービスに中断、中止その他の障害が生じないことを保証しません。</p>
          <p>2. 当社は、HubSpot、Slack、Stripeその他本サービスが連携する第三者サービスの仕様変更、API利用制限（レートリミット）の超過、サービスの停止又は終了等により本サービスの機能が制限され、又は利用できなくなることについて、一切の責任を負いません。</p>
          <p>3. ユーザーが本サービスを利用するにあたり、本サービスから本サービスに関わる第三者が運営する他のサービス（以下「外部サービス」といいます。）と連携し、又は外部サービスに遷移する場合があります。その場合、ユーザーは、自らの責任と負担で外部サービスの利用規約等に同意の上、本サービス及び外部サービスを利用します。なお、外部サービスの内容について、その完全性、正確性、有用性及び有効性等について、当社は一切の保証をしません。</p>
          <p>4. ユーザーが登録情報の変更を行わなかったことにより損害を被った場合でも、当社は一切の責任を負いません。</p>
          <p>5. ユーザーは、法令の範囲内で本サービスをご利用ください。本サービスの利用に関連してユーザーが日本又は外国の法令に触れた場合でも、当社は一切の責任を負いません。</p>
          <p>6. 当社が本規約及び別途定めるセキュリティ基準に従い合理的な安全管理措置を講じていたにもかかわらず、予期しない不正アクセス等の行為によってユーザー情報が盗取された場合、それによって生じるユーザーの損害等に対して、当社は責任を負いません。</p>
          <p>7. 当社は、天災、地変、火災、ストライキ、通商停止、戦争、内乱、感染症の流行その他の不可抗力により本契約の全部又は一部に不履行が発生した場合、一切の責任を負いません。</p>
          <p>8. 本サービスの利用に関し、ユーザーが他のユーザーとの間でトラブル（本サービス内外を問いません。）になった場合でも、当社は一切の責任を負わず、ユーザー間のトラブルは、当該ユーザーが自らの費用と負担において解決します。</p>
          <p>9. 本サービスの利用が、連携先（HubSpotおよびSlack等）の定めるAPI利用制限を超過した場合、一時的に機能が制限されることがありますが、当社はこれについて責任を負いません。</p>
          <p>10. 当社が本サービスに関連してユーザーに対して損害賠償責任を負う場合であっても、当社の賠償責任は、当社の故意又は重過失に基づく場合を除き、ユーザーに現実に生じた通常の損害に限られるものとし、かつ、損害の事由が生じた時点から遡って直近3か月の期間にユーザーから現実に受領した本サービスの利用料金の総額を上限とします。</p>

          <h2>第17条（損害賠償）</h2>
          <p>1. ユーザーは、本規約の違反又は本サービスの利用に関連して当社に損害を与えた場合、当社に発生した損害（逸失利益及び弁護士費用を含みます。）を賠償します。</p>
          <p>2. 当社が本サービスに関連してユーザーに対して損害賠償責任を負う場合の範囲及び上限は、前条第10項の定めに従うものとします。</p>

          <h2>第18条（利用料金の未払いによる停止）</h2>
          <p>1. ユーザーが、Hub ID（ポータルID）単位で発生する利用料金について、当社指定の決済日に決済が完了しなかった場合、当社は、当該Hub IDに紐づく管理者に対し通知を行います。</p>
          <p>2. オンライン決済（Stripe）による支払が当該決済日から14日以内に完了しない場合、当社は、当該Hub IDに係る本サービスの全部又は一部の提供を停止することができます。</p>
          <p>3. 請求書払いの場合において、支払期限を経過してもなお支払がなされないときは、当社は、支払期限から14日経過後、当該Hub IDに係る本サービスの全部又は一部の提供を停止することができます。</p>
          <p>4. 各項に基づく停止期間中であっても、利用料金の支払義務は免れません。</p>

          <h2>第19条（本サービスの提供条件）</h2>
          <p>当社は、以下の各号のいずれかに該当する場合、ユーザーに通知することなく、本サービスを停止又は変更することがあります。</p>
          <ol>
            <li>本サービスの提供に必要となるコンピューター、サーバ、通信回線その他の設備（以下「本サービス設備」といいます。）の故障、障害、誤操作の発生、不正アクセス、過度なアクセスの集中その他の理由により本サービスの提供ができなくなった場合</li>
            <li>本サービス設備の点検、保守、修理又は変更等を行う場合</li>
            <li>天災、地変、火災、ストライキ、通商停止、戦争、内乱、感染症の流行その他の不可抗力により本サービスの提供ができなくなった場合</li>
            <li>法令又はこれに基づく措置により本サービスの提供ができなくなった場合</li>
            <li>本サービスの提供に必要となる第三者により提供されるサービス（HubSpot及びSlackを含む）の全部又は一部の提供が停止又は中断された場合</li>
            <li>その他当社が停止又は変更を必要と判断した場合</li>
          </ol>

          <h2>第20条（本サービスの廃止）</h2>
          <p>1. 当社は、当社が本サービスの提供を廃止すべきと合理的に判断した場合、ユーザーに対して廃止日の30日前までに通知したうえで、本サービスの提供を廃止できます。ただし、法令上の要請その他やむを得ない事由がある場合は、この限りではありません。</p>
          <p>2. 前項の場合、当社に故意又は重過失がある場合を除き、当社は一切の責任を負いません。</p>

          <h2>第21条（遅延損害金）</h2>
          <p>ユーザーが、請求書払いその他当社が別途認めた支払方法により負担する金銭債務について、当社の指定する期日までに支払いを行わなかった場合は、支払期日の翌日から支払い済みに至るまで、年14.6％の日割計算による遅延損害金を支払うものとします。なお、Stripeその他オンライン決済手段による支払いについては、当該決済事業者の定める規約に従うものとします。</p>

          <h2>第22条（秘密保持）</h2>
          <p>1. ユーザー及び当社は、本サービスの提供又は利用に関して知り得た相手方の秘密情報（本サービスに関するノウハウ、当社のシステムに関する情報、技術上又は営業上の一切の秘密情報を含みます。）を、厳重かつ適正に管理するものとし、相手方の事前の書面による同意なく第三者に開示、提供及び漏洩し、又は本サービスの提供若しくは利用の目的以外に使用してはならないものとします。</p>
          <p>2. 次の各号の情報は、秘密情報に該当しないものとします。</p>
          <ol>
            <li>開示を受けた時、既に所有していた情報</li>
            <li>開示を受けた時、既に公知であった情報又はその後自己の責に帰さない事由により公知となった情報</li>
            <li>開示を受けた後に、第三者から合法的に取得した情報</li>
            <li>開示された秘密情報によらず独自に開発し又は創作した情報</li>
          </ol>
          <p>3. ユーザー及び当社は、相手方の指示があった場合又は本契約が終了した場合は、相手方の指示に従い速やかに秘密情報を、原状に回復した上で返却又は廃棄し、以後使用しないものとします。</p>
          <p>4. 第1項の規定にかかわらず、当社は、本サービスの提供に必要な範囲において、当社の関連会社又は委託先にユーザーの秘密情報を開示することができます。この場合、当社は当該関連会社又は委託先に対し、本条に定める秘密保持義務と同等の義務を課すものとします。ただし、当社が選任及び監督について合理的な注意を尽くした場合には、当該関連会社又は委託先の行為に起因してユーザーに生じた損害について、当社は責任を負わないものとします。</p>
          <p>5. 当社は、本サービスを提供する目的のために、ユーザーの秘密情報を利用することができます。</p>
          <p>6. 第1項の規定にかかわらず、当社は、法令、裁判所、行政庁又は規制権限を有する公的機関の規則、裁判、命令、指示等により秘密情報の開示を要求される場合、必要な範囲で秘密情報を開示することができます。</p>
          <p>7. 本条に定める秘密保持義務</p>

          <h2>第23条（反社会的勢力の排除）</h2>
          <p>1. ユーザー及び当社は、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下総称して「暴力団員等」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証します。</p>
          <ol>
            <li>暴力団員等が経営を支配していると認められる関係を有すること。</li>
            <li>暴力団員等が経営に実質的に関与していると認められる関係を有すること。</li>
            <li>自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってする等、不当に暴力団員等を利用していると認められる関係を有すること。</li>
            <li>暴力団員等に対して資金等を提供し、又は便宜を供与する等の関与をしていると認められる関係を有すること。</li>
            <li>役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること。</li>
          </ol>
          <p>2. ユーザー及び当社は、自ら又は第三者を利用して次の各号のいずれかに該当する行為を行わないことを確約します。</p>
          <ol>
            <li>暴力的な要求行為</li>
            <li>法的な責任を超えた不当な要求行為</li>
            <li>取引に関して、脅迫的な言動をし、又は暴力を用いる行為</li>
            <li>風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為</li>
            <li>その他前各号に準ずる行為</li>
          </ol>
          <p>3. ユーザー及び当社は、相手方が、暴力団員等若しくは第1項各号のいずれかに該当し、若しくは前項各号のいずれかに該当する行為をし、又は第1項の規定にもとづく表明・保証に関して虚偽の申告をしたことが判明した場合には、自己の責に帰すべき事由の有無を問わず、相手方に対して何らの催告をすることなく本契約を解除することができます。</p>
          <p>4. ユーザー及び当社は、前項により本契約を解除した場合、相手方に損害が生じたとしてもこれを一切賠償する責任はないことを確認し、これを了承します。</p>

          <h2>第24条（お問い合わせ）</h2>
          <p>1. 当社は、本サービスに関するユーザーからのお問い合わせに対して回答するよう努めますが、法令又は本規約上、当社に義務又は責任が発生する場合を除き、回答の義務を負いません。</p>
          <p>2. 当社は、ユーザーからのお問い合わせに回答するか否かの基準を開示する義務を負いません。</p>
          <p>3. HubSpot・Slack本体に関するお問い合わせは、当社のサポート対象外となります。</p>

          <h2>第25条（地位の譲渡）</h2>
          <p>1. ユーザーは、当社の書面による事前の承諾なく、本契約上の地位又は本規約に基づく権利若しくは義務を第三者に対し譲渡、移転、担保設定その他の処分をすることはできません。</p>
          <p>2. 当社は、本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他の態様を含みます。）した場合には、当該事業譲渡に伴い本契約上の地位並びに本規約に基づく権利及び義務を当該第三者に承継させることができるものとし、ユーザーはあらかじめこれに同意するものとします。</p>

          <h2>第26条（個人情報の取扱い）</h2>
          <p>1. ユーザーは、本サービスの利用に際して第三者の個人情報を取り扱う場合、当該個人情報を機密として適切に管理し、第三者に開示又は漏洩してはならず、本サービスの利用目的の範囲を超えて利用してはならないものとします。</p>
          <p>2. 当社は、本サービスの提供に関連して取得又はユーザーから委託を受けて取り扱う個人情報について、当社が別途定め、当社ウェブサイト上で公表する「個人情報の取扱いについて」に従い、適切に取り扱うものとします。</p>
          <p>3. 当社は、個人情報の取扱いの全部又は一部を第三者に委託する場合、当該委託先に対して個人情報の安全管理に関する契約上の義務を課し、必要かつ適切な監督を行うものとします。</p>
          <p>4. 当社は、本サービスに関連して個人情報の漏えい、滅失又はき損その他の安全管理上の事故が発生したことを認識した場合、法令に従い必要な調査・措置を講じ、必要に応じてユーザーに対し速やかに通知します。</p>
          <p>5. ユーザーは、当社による個人情報の取扱いについて、当社のプライバシーポリシーの範囲内で合理的な説明を求めることができ、当社はこれに誠実に対応するものとします。</p>
          <p>6. 本サービスの提供にあたり、当社がユーザーの個人データを取り扱う場合、当社は個人情報の保護に関する法律に基づく受託者として、法令及び当社が別途定めるセキュリティ基準に従い、適切な安全管理措置を講じるものとします。</p>

          <h2>第27条（Cookie等）</h2>
          <p>1. 当社は、本サービスの品質向上、利用状況の分析等の目的で、Cookie、IPアドレス、アクセスログ等の情報を取得・利用する場合があります。</p>
          <p>2. これらの情報の取扱いについては、「個人情報の取扱いについて」に定めるところによります。</p>

          <h2>第28条（分離可能性）</h2>
          <p>1. 本規約の規定の一部が法令に基づいて無効と判断されても、本規約の他の規定は有効とします。</p>
          <p>2. 本規約の規定の一部があるユーザーとの関係で無効又は取消となった場合でも、本規約は他のユーザーとの関係では有効とします。</p>

          <h2>第29条（違反行為への対処）</h2>
          <p>1. ユーザーは、本規約に違反する行為を発見した場合は、当社にご連絡ください。</p>
          <p>2. ユーザーは、本規約に違反する行為への当社の対処について、異議を申し立てることはできません。</p>

          <h2>第30条（存続条項）</h2>
          <p>第8条、第10条、第11条、第15条第3項、第16条、第17条、第18条第4項、第20条、第21条、第22条、第23条第4項、第25条、第26条、第27条、第28条、本条、第32条及び第33条の規定は、本契約の終了後も有効に存続するものとします。ただし、第22条については、同条第7項に定める期間に限り、第26条及び第27条については、当社がユーザーデータの削除を完了するまでの間に限るものとします。</p>

          <h2>第31条（規約変更および通知）</h2>
          <p>1. 当社が本サービスに関してユーザーに通知を行う必要があると判断した場合、本サービス上への表示、当社ウェブサイトへの掲載、電子メールその他当社所定の方法により行うものとします。</p>
          <p>2. 当社が前項の方法により通知を行った場合、電子メールによる通知は当社が送信した時点で、ウェブサイト又は本サービス上への掲載による通知は当該内容を掲載した時点で、それぞれユーザーに到達したものとみなします。</p>
          <p>3. 当社は、以下の各号のいずれかに該当する場合は、民法第548条の4の規定に基づき本規約を随時変更することができるものとします。本規約が変更された後の本契約には、変更後の本規約が適用されます。</p>
          <ol>
            <li>本規約の変更が、ユーザーの一般の利益に適合するとき。</li>
            <li>本規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性及びその内容その他の変更に係る事情に照らして合理的なものであるとき。</li>
          </ol>
          <p>4. 当社は、本規約の変更を行う場合は、変更後の本規約の効力発生時期を定め、あらかじめ、変更後の本規約の内容及び効力発生時期をユーザーに通知し、又は本サービス上への表示その他当社所定の方法によりユーザーに周知します。</p>
          <p>5. 前項の規定にかかわらず、変更後の本規約の効力発生日以後にユーザーが本サービスを利用した場合、当該ユーザーは本規約の変更に同意したものとします。</p>

          <h2>第32条（準拠法）</h2>
          <p>本規約に関する準拠法は、全て日本国の法令が適用されます。</p>

          <h2>第33条（管轄）</h2>
          <p>ユーザーと当社との間における一切の訴訟は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>

          <h2>第34条（協議解決）</h2>
          <p>本規約に定めのない事項又は本規約の解釈に疑義が生じた事項については、ユーザー及び当社は誠意をもって協議の上、解決を図るものとします。</p>

          <div className="legal-appendix">
            <p>付則</p>
            <p>2026年3月〇日：制定・施行</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
